module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAHlBMVEUAUpP+ywDKysr4yAP/1gAAS5sCU5IrZno3bHNZfGAhnEImAAAA+0lEQVR42u3ZO0pDYRSF0YOF/U0cgMZXb2agAbUVotYWGYBNcPYWdt40G37IIaxvBKveu1Ytq8sKOv98mv61fHmv4Z1hYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhHYl1t0s6yNoN76tut0kfc9bzdnxvdb9P+pmzXvfj+66bTdQ062Izvse6XkfNWcv1+B7qamrYAgvrL6wkrCSsJKwkrCSsJKwkrCSsJKwkrCSsJKwkrKO26LoGNt1Omy7NTXf5pi9G088HCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwvr5Fmrlv0CtBZ3brE26lMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/23.png
// module id = 9cEc
// module chunks = 1